export const companyInfo = {
  name: "P.D.R. Comfort Systems L.L.C.",
  tagline: "Take Comfort in knowing I will make you comfortable as soon as I possibly can.",
  phone: "(330) 998-5161",
  emergencyPhone: "(330) 998-5161",
  email: "clevelandheaters@gmail.com",
  address: "9931 Ridgewood Drive, Twinsburg, Ohio 44087",
  hours: "Mon-Sat: 8AM-5PM",
  description: "P.D.R. Comfort Systems provides professional heating, cooling, and plumbing services in Twinsburg and the Greater Cleveland area. Emergency services available 24 hours daily."
};

export const services = [
  {
    id: 1,
    title: "Heating Installation & Repair",
    description: "Expert furnace and heating system installation, repair, and maintenance to keep you warm all winter.",
    icon: "flame",
    features: [
      "Furnace installation & repair",
      "Heat pump services",
      "Boiler repair",
      "Thermostat installation",
      "Same-day service available"
    ]
  },
  {
    id: 2,
    title: "Air Conditioning Services",
    description: "Professional AC installation, repair, and maintenance to keep you cool during hot summer months.",
    icon: "snowflake",
    features: [
      "AC installation & repair",
      "AC maintenance",
      "Central air systems",
      "Emergency AC service",
      "Energy-efficient upgrades"
    ]
  },
  {
    id: 3,
    title: "Plumbing Services",
    description: "Comprehensive plumbing solutions including water heaters, pipe repairs, and emergency plumbing services.",
    icon: "wrench",
    features: [
      "Water heater repair & replacement",
      "Pipe burst fixes",
      "Flue adjustments",
      "Emergency plumbing",
      "Leak detection & repair"
    ]
  },
  {
    id: 4,
    title: "Emergency Services",
    description: "24/7 emergency HVAC and plumbing services when you need us most. Fast response times guaranteed.",
    icon: "phone-call",
    features: [
      "Same-day service",
      "Weekend availability",
      "Fast response time",
      "CO alarm response",
      "Fair, transparent pricing"
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    location: "Local Homeowner",
    rating: 5,
    text: "PDR Comfort Systems saved the day when our AC broke down in July! They arrived within 2 hours and had us cool again. Highly professional and reasonably priced."
  },
  {
    id: 2,
    name: "Mike Patterson",
    location: "Business Owner",
    rating: 5,
    text: "We've been using PDR for our commercial HVAC needs for 3 years. Their maintenance plans have saved us thousands in potential repairs. Can't recommend them enough!"
  },
  {
    id: 3,
    name: "Jennifer Martinez",
    location: "Residential Customer",
    rating: 5,
    text: "Professional, courteous, and knowledgeable. They installed our new furnace and the difference is amazing. Lower energy bills and a warmer home!"
  },
  {
    id: 4,
    name: "David Chen",
    location: "Property Manager",
    rating: 5,
    text: "Managing multiple properties, I need reliable HVAC service. PDR has never let me down. Quick response, fair pricing, and quality work every time."
  }
];

export const whyChooseUs = [
  {
    title: "4.7 Star Rating",
    description: "Highly rated by 85+ satisfied customers in Cleveland area",
    icon: "award"
  },
  {
    title: "Licensed & Insured",
    description: "Fully certified technicians you can trust",
    icon: "shield-check"
  },
  {
    title: "Same-Day Service",
    description: "Fast response with weekend emergency availability",
    icon: "clock"
  },
  {
    title: "Fair Pricing",
    description: "Transparent, honest pricing with no hidden fees",
    icon: "thumbs-up"
  }
];

export const aboutContent = {
  mission: "To provide exceptional heating and cooling services that exceed customer expectations while maintaining the highest standards of professionalism and integrity.",
  story: "Founded over 20 years ago, P.D.R. Comfort Systems has grown from a small local business to one of the most trusted HVAC companies in the region. Our commitment to quality service and customer satisfaction has been the cornerstone of our success.",
  values: [
    {
      title: "Integrity",
      description: "We believe in honest, transparent service with no hidden fees or unnecessary repairs."
    },
    {
      title: "Excellence",
      description: "Every job is completed to the highest standards, whether it's a simple repair or complex installation."
    },
    {
      title: "Customer First",
      description: "Your comfort and satisfaction are our top priorities in everything we do."
    }
  ]
};